import {useState, useMemo} from "react";
import {useSearchParams} from "react-router-dom";
import {CreateOption, OptionType} from "../components/home/new-offering/options/options";
import {useNavigate} from "react-router-dom";
import {message} from "antd";

export const mockOptions: CreateOption[] = [
  {
    id: "one_on_one",
    type: "event",
    label: "1:1 sessions",
    description: "Let people book a single focused session.",
    borderColor: "#10260B",
    bgColor: "#DFFCD8",
    link: "/calls/new",
    img: "/images/sessions-2.png",
  },
  {
    id: "session_bundles",
    type: "event",
    label: "1:1 session bundles",
    description: "Sell a pack of multiple sessions together.",
    borderColor: "#002421",
    bgColor: "#E1F6F5",
    link: "/calls/bundle/new",
    img: "/images/product-1.png",
  },
  {
    id: "live_events",
    type: "event",
    label: "Live events",
    description: "Sell tickets to online or in-person events.",
    borderColor: "#10260B",
    bgColor: "#E0F5E3",
    link: "/live-classes/new",
    img: "/images/sessions-1.png",
  },
  {
    id: "digital_products",
    type: "product",
    label: "Products",
    description: "Sell downloadable files like PDFs, templates, or videos.",
    borderColor: "#613400",
    bgColor: "#FFFBE6",
    link: "/products/new",
    img: "/images/digital-products.png",
  },
  {
    id: "services",
    type: "product",
    label: "Services",
    description: "Offer custom work or project-based deliverables.",
    borderColor: "#030852",
    bgColor: "#D6E4FF",

    img: "/images/services.png",
    link: "/products/services/new",
  },
  {
    id: "subscriptions",
    type: "product",
    label: "Subscriptions",
    description: "Take recurring payments for ongoing access or benefits.",
    borderColor: "#10260B",
    bgColor: "#E7EDE1",
    img: "/images/subscriptions.png",
    link: "/products/subscriptions/new",
    tag: "New",
  },
  {
    id: "courses",
    type: "product",
    label: "Courses",
    description: "Provide online lessons with video or audio content.",
    borderColor: "#10260B",
    bgColor: "#DFFCD8",
    tag: "Coming soon",
    isComingSoon: true,
    img: "/images/courses.png",
  },
];

export const useOfferingOptions = () => {
  const [searchParams] = useSearchParams();
  const [selected, setSelected] = useState<CreateOption | undefined>(undefined);
  const mode = (searchParams.get("selectOption") as OptionType | "none") || "none";
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const {topSectionOptions, bottomSectionOptions} = useMemo(() => {
    if (mode === "none") {
      return {
        topSectionOptions: mockOptions,
        bottomSectionOptions: [],
      };
    }

    return {
      topSectionOptions: mockOptions.filter((option) => option.type === mode),
      bottomSectionOptions: mockOptions.filter((option) => option.type !== mode),
    };
  }, [mode]);

  const handleOptionClick = (option: CreateOption) => {
    setSelected(option);
  };

  const handleContinue = () => {
    if (selected) {
      const selectedOption = mockOptions.find((o) => o.id === selected.id);
      if (selectedOption?.link) {
        navigate(`${selectedOption.link}`);
      } else {
        messageApi.info({
          type: "info",
          content: "This feature is not yet available.",
          duration: 6,
        });
      }
    }
  };

  const handleCancel = () => {
    setSelected(undefined);
    navigate(-1);
  };

  return {
    mode,
    selected,
    topSectionOptions,
    bottomSectionOptions,
    handleOptionClick,
    handleContinue,
    handleCancel,
    setSelected,
    contextHolder,
  };
};
